export const LOGIN_REQUEST = 'MYPAGE_LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'MYPAGE_LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'MYPAGE_LOGIN_FAILURE';

export const LOGOUT_REQUEST = 'MYPAGE_LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'MYPAGE_LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'MYPAGE_LOGOUT_FAILURE';

export const VERIFY_JWT_REQUEST = 'VERIFY_JWT_REQUEST';
export const VERIFY_JWT_FAILURE = 'VERIFY_JWT_FAILURE';
export const VERIFY_JWT_SUCCESS = 'VERIFY_JWT_SUCCESS';

export const EXCHANGE_PULSE_TOKEN_REQUEST = 'EXCHANGE_PULSE_TOKEN_REQUEST';
export const EXCHANGE_PULSE_TOKEN_SUCCESS = 'EXCHANGE_PULSE_TOKEN_SUCCESS';
export const EXCHANGE_PULSE_TOKEN_FAILURE = 'EXCHANGE_PULSE_TOKEN_FAILURE';

export const LOGIN_USER_USING_SCHIBSTED_ACCOUNT = 'LOGIN_USER_USING_SCHIBSTED_ACCOUNT';
export const LOGIN_USER_USING_PULSE = 'LOGIN_USER_USING_PULSE';
export const FORCE_NEW_SESSION = 'FORCE_NEW_SESSION';
export const MY_PAGE_AUTH_COMPLETE = 'MY_PAGE_AUTH_COMPLETE';
export const SCHIBSTED_ACCOUNT_LOGIN = 'SCHIBSTED_ACCOUNT_LOGIN';
export const LOGIN_DIFFERENT_ACCOUNT = 'SCHIBSTED_ACCOUNT_LOGIN_DIFFERENT_ACCOUNT';
